import Action, { ActionPayments , ActionPaymentsFetchError, ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import PaymentsState from '../State/PaymentsState'

const actionPaymentsFetchError = (oldState: PaymentsState, action: Action): PaymentsState => {
    return { ...oldState, error: (action as ActionPaymentsFetchError).message, loading: false }
}

const actionPaymentsFetchLoading = (oldState: PaymentsState, _action: Action): PaymentsState => {
    return { ...oldState, loading: true, error: undefined }
}

const actionPayments = (oldState: PaymentsState, action: Action): PaymentsState => {
    return { ...oldState, loading: false, error: undefined, data: (action as ActionPayments).list }
}

type Process = (oldState: PaymentsState, action: Action) => PaymentsState

export const PaymentsReducer: Reducer<PaymentsState, Action> = (state: PaymentsState = {
    data: [], loading: false, error: undefined
}, action: Action): PaymentsState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.PAYMENTS_LOADING, actionPaymentsFetchLoading)
    actionMap.set(ActionType.PAYMENTS_DATA, actionPayments)
    actionMap.set(ActionType.PAYMENTS_ERROR, actionPaymentsFetchError)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}
